<template>
  <a
    class="block"
    @click.stop="params.colDef.CellRendererParams.paySlipSidebarFunction(params.data.id)"
    ><span class="material-icons">visibility</span></a
  >
</template>

<script>
export default {
  name: 'ViewCell'
}
</script>